import { IAppState } from 'src/store/types';

export const getFilterInitialData = (state: IAppState) => state.requests.filter.data;
export const getFilterInitialAllData = (state: IAppState) => state.requests.filter.data;
export const getFilterInitialDataLoading = (state: IAppState) => state.requests.filter.isLoading;
export const getFilterInitialDataErrors = (state: IAppState) => state.requests.filter.error;
